export * from './CategoriesIndexPage.query';
export { default as CategoriesIndexPage } from './CategoriesIndexPage';
